import axios from 'axios'
import { config } from '../../../../../../../../../../constants'
import { createElevenLabVoice, getElevenLabsVoices } from '../../../../../../../../../../services/api/audioSynthesizer'

export const fetchVoices = async () => {
  try {
    const response = await getElevenLabsVoices()
    if (response?.data) {
      return response.data?.voices || []
    } else {
      throw new Error('Failed to fetch voices')
    }
  } catch (error) {
    throw new Error('Failed to fetch voices')
  }
}

export const generateVoiceover = async (text, selectedVoice, settings) => {
  console.log("test", settings)
  try {
    const response = await createElevenLabVoice({
      text,
      voice_id: selectedVoice && selectedVoice.voice_id ? selectedVoice.voice_id : undefined,
      course_id: settings.course_id,
      lesson_id: settings.lesson_id,
      org_id: settings.org_id,
      user_id: settings.user_id,
    })
    var data = response && response.data ? response.data : null

    // Check if the API returned an S3 URL and Key
    if (data && data.url && data.key) {
      return data;
    }

    // Expect constant Lambda-style base64 response: { isBase64Encoded, body }
    if (data && typeof data === 'object' && Object.prototype.hasOwnProperty.call(data, 'body')) {
      var base64 = data.body
      var binaryString = atob(base64)
      var len = binaryString.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      var blob = new Blob([bytes], { type: 'audio/mpeg' })
      return URL.createObjectURL(blob)
    }
    // Minimal fallback if backend ever returns a Blob directly
    if (typeof Blob !== 'undefined' && data instanceof Blob) {
      return URL.createObjectURL(data)
    }
    throw new Error('Unsupported voiceover response format')
  } catch (error) {
    throw new Error('Failed to generate voiceover')
  }
}

export const defaultSettings = {
  model: 'eleven_multilingual_v2',
  stability: 0.5,
  similarity_boost: 0.75,
  style: 0.5,
  use_speaker_boost: true
}

export const filterVoices = (voices, searchQuery) => {
  return voices.filter(voice => {
    const matchesName = voice.name
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
    const matchesLabels = Object.values(voice.labels || {}).some(value =>
      value.toLowerCase().includes(searchQuery.toLowerCase())
    )
    return matchesName || matchesLabels
  })
}

export const getLabelIcon = labelType => {
  const iconMap = {
    accent: 'global',
    description: 'info-circle',
    age: 'user',
    gender: 'team',
    use_case: 'tag'
  }
  return iconMap[labelType] || 'tag'
}

export const createAudioPlayer = (previewUrl, onEnd) => {
  const audio = new Audio(previewUrl)
  audio.onended = onEnd
  return audio
}

export class AudioManager {
  constructor(onPlayingStateChange) {
    this.currentAudio = null
    this.playingVoiceId = null
    this.onPlayingStateChange = onPlayingStateChange
  }

  play(voiceId, previewUrl) {
    this.stop()

    const audio = new Audio(previewUrl)
    audio.onended = () => {
      this.currentAudio = null
      this.playingVoiceId = null
      if (this.onPlayingStateChange) {
        this.onPlayingStateChange(null)
      }
    }

    this.currentAudio = audio
    this.playingVoiceId = voiceId
    if (this.onPlayingStateChange) {
      this.onPlayingStateChange(voiceId)
    }
    audio.play()
  }

  stop() {
    if (this.currentAudio) {
      this.currentAudio.pause()
      this.currentAudio.currentTime = 0
      this.currentAudio = null
      this.playingVoiceId = null
      if (this.onPlayingStateChange) {
        this.onPlayingStateChange(null)
      }
    }
  }

  isPlaying(voiceId) {
    return this.playingVoiceId === voiceId
  }

  stopAll() {
    const audioElements = document.querySelectorAll('audio')
    audioElements.forEach(audio => {
      audio.pause()
      audio.currentTime = 0
    })
    this.currentAudio = null
    this.playingVoiceId = null
    if (this.onPlayingStateChange) {
      this.onPlayingStateChange(null)
    }
  }
}
